<template>
  <div>
    <RightTitle title="建站工具"></RightTitle>

    <!-- 搜索表单 -->
    <div class="uar_form">
      <el-form ref="form" :inline="true" :model="filter" label-width="80px" size="medium">
        <el-form-item label="标题">
          <el-input v-model="filter.title" clearable placeholder="搜索标题"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">搜索</el-button>
        </el-form-item>
        <el-form-item v-if="loginUserInfo.level == 2">
          <el-button @click="addTemplate">添加工具</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 数据表格 -->
    <div class="uar_form">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column label="标题" prop="title" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="分类" prop="artTypeName" width="100" align="center"></el-table-column>
        <el-table-column label="时间" prop="addTime" width="150" align="center"></el-table-column>
        <el-table-column label="状态" prop="status" width="120" align="center">
          <template slot-scope="scope">
            <span class="green" v-if="scope.row.status == 0">审核中</span>
            <span v-else-if="scope.row.status == 1">审核通过</span>
            <span class="red" v-else-if="scope.row.status == 2">审核不通过</span>
            <span class="blue" v-else-if="scope.row.status == 3">关闭</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" align="center">
          <template slot-scope="scope">
            <el-button-group>
              <el-tooltip content="查看详情">
                <el-button
                  type="primary"
                  icon="el-icon-search"
                  size="small"
                  @click="showInfo(scope.row)"
                ></el-button>
              </el-tooltip>
              <el-tooltip content="编辑">
                <el-button
                  type="primary"
                  icon="el-icon-edit"
                  size="small"
                  @click="editArt(scope.row)"
                ></el-button>
              </el-tooltip>
              <el-tooltip content="删除">
                <el-button
                  type="primary"
                  icon="el-icon-delete"
                  size="small"
                  @click="deleteArt(scope.row)"
                ></el-button>
              </el-tooltip>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <div class="uar_form page_area">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="dataTotal"
        :current-page.sync="page"
        @current-change="currentChange"
        v-if="dataTotal > 0"
      ></el-pagination>
    </div>

    <!-- 表单内容 -->
    <el-dialog :title="dialogTitle" :visible.sync="formVisible" width="50%">
      <ToolsForm ref="form" :artId="editArtId"></ToolsForm>
      <span slot="footer" class="dialog-footer">
        <el-button @click="formVisible = false">取 消</el-button>
        <el-button type="primary" :loading="loading" @click="submit">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 查看详情 -->
    <el-dialog :title="dialogTitle" :visible.sync="infoVisible" width="50%">
      <ToolsInfo :artId="infoArtId"></ToolsInfo>
    </el-dialog>
  </div>
</template>

<script>
// 加载组件
import axios from "axios";
import RightTitle from "../../../components/RightTitle";
import ToolsForm from "./components/ToolsForm";
import ToolsInfo from "./components/ToolsInfo";
// 加载api
import { getArts, deleteArt } from "../../../api/art";
import { getUserInfo } from "../../../api/user";
// 加载函数
import { formatQuery } from "../../../utils/fn";
export default {
  name: "course_tools",
  components: {
    RightTitle,
    ToolsForm,
    ToolsInfo
  },
  beforeRouteEnter(to, from, next) {
    axios.all([getUserInfo(), getArts({ ...to.query, type: "tools" })]).then(
        axios.spread((userInfo, arts) => {
            next(vm => {
                vm.loginUserInfo = userInfo.data;
                vm.tableData = arts.data.list;
                vm.dataTotal = arts.data.count;
            })
        })
    );
  },

  beforeRouteUpdate(to, from, next) {
    getArts({ ...to.query, type: "tools" }).then(res => {
      this.tableData = res.data.list;
      this.dataTotal = res.data.count;
    });
    next();
  },
  data() {
    return {
      filter: {
        title: ""
      },
      tableData: [],
      dataTotal: 0,
      page: 1,
      formVisible: false,
      infoVisible: false,
      dialogTitle: "添加工具",
      infoArtId: 0,
      editArtId: 0,
      loading: false,
      // 登录用户信息
      loginUserInfo: {}
    };
  },
  methods: {
    //   添加
    addTemplate() {
      this.formVisible = true;
      this.dialogTitle = "添加工具";
      this.loading = false;
      this.infoArtId = 0;
      this.editArtId = 0;
    },
    showInfo(row) {
      this.infoVisible = true;
      this.dialogTitle = "文章详情";
      this.infoArtId = row.id;
    },
    editArt(row) {
      this.formVisible = true;
      this.dialogTitle = "编辑工具";
      this.infoArtId = 0;
      this.editArtId = row.id;
      this.loading = false;
    },
    deleteArt(row) {
      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "删除",
        cancelButtonText: "不删除",
        type: "warning"
      })
        .then(() => {
          deleteArt({ artID: row.id }).then(res => {
            if (res.status == 200) {
              this.$notify({
                title: "成功",
                message: res.message,
                type: "success"
              });
              this.$router.push({
                query: { ...formatQuery(this.filter), page: 1 }
              });
            } else {
              this.$notify({
                title: "警告",
                message: res.message,
                type: "warning"
              });
            }
          });
        })
        .catch(() => {});
    },
    // 改变当前页
    currentChange(page) {
      this.page = page;
      this.$router.push({ query: { ...this.$route.query, page } });
    },
    // 搜索
    search() {
      this.page = 1;
      this.$router.push({ query: { ...formatQuery(this.filter), page: 1 } });
    },
    // 提交
    submit() {
      this.loading = true;
      this.$refs.form.submit().then(res => {
        if (res) {
          this.formVisible = false;
          this.infoArtId = 0;
          this.editArtId = 0;
          this.$router.push({
            query: { ...formatQuery(this.filter), page: 1 }
          });
        } else {
          this.loading = false;
        }
      });
    }
  }
};
</script>

<style scoped>
.space {
  margin-right: 5px;
}
</style>